import React from "react";
export default function Qa(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M7.50009 13.4611C10.7923 13.4611 13.4611 10.7923 13.4611 7.50009C13.4611 4.20791 10.7923 1.53906 7.50009 1.53906C4.20791 1.53906 1.53906 4.20791 1.53906 7.50009C1.53906 10.7923 4.20791 13.4611 7.50009 13.4611Z"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path d="M7.5 10.3247V7.37109" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
			<path
				d="M7.49976 5.96924C7.851 5.96924 8.13574 5.6845 8.13574 5.33325C8.13574 4.98201 7.851 4.69727 7.49976 4.69727C7.14851 4.69727 6.86377 4.98201 6.86377 5.33325C6.86377 5.6845 7.14851 5.96924 7.49976 5.96924Z"
				fill="currentColor"
			/>
		</svg>
	);
}
